import { render, staticRenderFns } from "./CreateItem.vue?vue&type=template&id=867ea30c&scoped=true&"
import script from "./CreateItem.vue?vue&type=script&lang=js&"
export * from "./CreateItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateItem.vue?vue&type=style&index=0&id=867ea30c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867ea30c",
  null
  
)

export default component.exports